import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { PaginatedAPI, employeeAPIModel } from 'src/app/models/api.model'
import { ExcelService } from '../excel/excel.service'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { fetch_employee_with_reference_details } from 'src/app/store/action/employee.action'

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private webservice: WebService, private excelService: ExcelService, private appState: Store<AppState>) {}

  invokeEmployeeSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_EMPLOYEE_SUMMARY_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<employeeAPIModel>) => data))
  }

  invokeSaveBulkEmployeeAPI(rowsToSave: employeeAPIModel[], documentToSave: File): Observable<any> {
    const endPoint = ServiceUrlConstants.API_SAVE_BULK_EMPLOYEE
    return this.webservice.post(endPoint, rowsToSave, null, [], false)
  }

  invokeUpdateBulkEmployeeAPI(rowsToSave: employeeAPIModel[], documentToSave: File): Observable<any> {
    const endPoint = ServiceUrlConstants.API_UPDATE_BULK_EMPLOYEE
    return this.webservice.post(endPoint, rowsToSave, null, [], false)
  }

  exportToExcel(options, documentType) {
    const endPoint = `${ServiceUrlConstants.API_EMPLOYEE_SUMMARY_LIST_EXPORT_CSV_XLS_V2 + documentType}`
    this.webservice.post(endPoint, options.requestBody, null, options.queryParams).subscribe(({ headers, data }) => {
      if (headers && data) {
        this.excelService.generateExcelFileWithHeaders(headers, data)
      }
    })
  }

  dispatchGetEmployeeWithReferenceDetails(employeeId: string) {
    this.appState.dispatch(fetch_employee_with_reference_details({ employeeId }))
  }

  getEmployeeWithReferenceDetails(employeeId: string) {
    return this.webservice.get(ServiceUrlConstants.API_EMPLOYEE_REFERENCE_DETAILS.replace('{0}', employeeId))
  }
}
